import { createAction, createReducer, on, props } from '@ngrx/store';
import { ThreeDS2ReducerInitState } from '../models/threeDS2-reducer.interface';

// Action Types
export const update3dsData = createAction('update3dsData', props<{ data: any }>());
export const reset3dsState = createAction('reset3dsState');

// Initial State
const initialState: ThreeDS2ReducerInitState = {
  data: {
    request: '',
    postURL: '',
    originURL: '',
    type: '',
    paymentSessionId: '',
    paymentRequest: '',
    termUrl: '',
    issueUrl: '',
    notificationUrl: ''
  }
};

// Reducer
export const threeDS2Reducer = createReducer(
  initialState,
  on(update3dsData, (state, { data }) => ({
    ...state,
    data
  })),
  on(reset3dsState, () => ({
    ...initialState
  }))
);
